/**
 * Z-Index Scale for Claude-style Layout
 *
 * Centralized z-index values to prevent conflicts and ensure
 * consistent layering across the application.
 *
 * MUI Default z-indexes (for reference):
 * - mobileStepper: 1000
 * - fab: 1050
 * - speedDial: 1050
 * - appBar: 1100
 * - drawer: 1200
 * - modal: 1300
 * - snackbar: 1400
 * - tooltip: 1500
 */

export const Z_INDEX = {
  // Base layer - Main content
  MAIN_CONTENT: 1,

  // Navigation layers
  NAV_RAIL: 1100,              // Persistent NavRail (always visible on desktop/tablet)
  THREAD_PANEL: 1100,          // ThreadPanel (same level as NavRail, sits beside it)
  THREAD_PANEL_BACKDROP: 1099, // Custom backdrop for tablet overlay (below panel, above content)

  // Mobile layers
  MOBILE_HEADER: 1200,         // Mobile header (above sidebar, same as MUI drawer)
  SIDEBAR_OVERLAY: 1300,       // Mobile sidebar overlay (above header, same as MUI modal)

  // Interactive elements
  USER_MENU_DROPDOWN: 1400,    // Dropdown menu (above sidebar overlay)

  // Top layers (existing MUI patterns)
  MODALS: 1500,                // Modals (no changes from existing)
  SNACKBARS: 1600,             // Toast notifications (no changes from existing)
  TOOLTIPS: 1700,              // Tooltips

  // Bottom navigation (mobile)
  BOTTOM_NAV: 1100,            // Mobile bottom tab bar (same level as nav rail)

  // Development banner (if used)
  DEV_BANNER: 1800,
};

// Layout dimensions (centralized for consistency)
export const LAYOUT = {
  // ── New unified sidebar widths ─────────────────────────────────────────────
  SIDEBAR_WIDTH_EXPANDED: 280,   // Full sidebar (sections, thread list, agents)
  SIDEBAR_WIDTH_COLLAPSED: 48,   // Icon-only strip (ChatGPT style)

  // ── Unchanged dimensions ───────────────────────────────────────────────────
  BOTTOM_NAV_HEIGHT: 56,
  MOBILE_HEADER_HEIGHT: 48,
  DEV_BANNER_HEIGHT: 32,
};

export default Z_INDEX;
